export default "__VITE_ASSET__cbafb851__"